<template>
  <div class="plateorder">
    <div class="plateorder-tabs vue_flex vue_flex_between vue_align_center">
      <div class="plateorder-tabs-input vue_flex vue_align_center">
        <div class="top_bar_inp vue_flex vue_align_center">
          <img
            class="top_bar_inp_img1 h"
            src="../../../../../assets/yimou/ss.png"
            alt=""
            @click="activeFun"
          />
          <input
            type="text"
            class="top_bar_inp_inp"
            v-model="searchValue"
            placeholder="平台、店铺、订单号、商品名称筛选"
          />
        </div>
      </div>
      <div
        class="plateorder-tabs-input-but vue-font-PingFang-500 color_255 h"
        @click="dialogimportVisible = true"
      >
        导入账单
      </div>
    </div>

    <!-- 批量删除按钮 - 设置margin-top:20px -->
    <div class="batch-delete-container" style="margin-top: 20px; margin-bottom: 15px; text-align: right;">
      <el-button 
        type="danger" 
        size="small" 
        @click="batchDelete"
        :loading="batchDeleteLoading"
        icon="el-icon-delete"
        :disabled="selectedRows.length === 0"
      >
        批量删除 (已选{{ selectedRows.length }}条)
      </el-button>
    </div>

    <div class="width_100" style="margin-top: 28px">
      <el-table
        :data="dataList"
        style="width: 100%"
        :header-cell-style="headercellstyle"
        border
        height="70vh"
        :key="'taobaoTable'"
        ref="orderTable"
        @selection-change="handleSelectionChange"
      >
        <!-- 批量选择列 -->
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column
          prop="goodsid"
          label="商品id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="fuwudanhao"
          label="服务单号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="time"
          label="售后申请时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="order_id"
          label="订单号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goodsname"
          label="商品名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="skuid"
          label="商品编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="status"
          label="出库状态"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goodsmoney"
          label="商品金额"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goodsnum"
          label="商品数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="tuikuanmoney"
          label="退款金额"
          align="center"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width" >
          <template slot-scope="row">
            <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="activeFun"
    />

    <el-dialog
      :visible.sync="dialogimportVisible"
      custom-class="unique-dialog"
      width="752px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="import-mask vue_flex vue_align_center vue_column">
        <div
          class="import-mask-title vue-font-PingFang-500 color_255 vue_relative"
        >
          导入订单
          <img
            src="../../../../../assets/yimou/gb.png"
            alt=""
            class="vue_absolute h"
            @click="
              (dialogimportVisible = false),
                (fileName = ''),
                (updatafileName = '')
            "
          />
        </div>
        <div class="import-mask-boxs vue_flex vue_column">
          <div class="import-mask-boxs-img vue_flex vue_column">
            <img src="../../../../../assets/yimou/dyb.png" alt="" />
            <div
              class="import-mask-boxs-img-view vue_flex vue_align_center vue_flex_between h"
            >
              <p class="vue-font-PingFang-500 color_35">导入模版</p>
              <div
                class="vue-font-PingFang-500 color_255"
                @click="downloadModel()"
              >
                下载
              </div>
            </div>
          </div>
          <div
            class="import-mask-boxs-upload size_no_repeat vue_flex vue_column vue_align_center"
          >
            <el-upload
              class="upload-demo"
              :http-request="leading"
              drag
              action
              multiple
              action="/"
              ref="limit"
              :show-file-list="false"
            >
              <div v-if="updatafileName == ''">
                <img src="../../../../../assets/yimou/cwj.png" alt="" />
                <p class="upload-title vue-font-PingFang-500">
                  <span>点击上传</span>
                </p>
                <p class="upload-content vue-font-PingFang-500 color_94">
                  只能上传 excel 文件
                </p>
              </div>
              <div v-else>
                <img
                  src="../../../../../assets/ym/excel.png"
                  alt=""
                  class="file-icon"
                />
                <div style="margin-top: 30px">{{ fileName }}</div>
              </div>
            </el-upload>
          </div>
        </div>
        <div
          class="import-mask-but vue-font-PingFang-500 color_255 h"
          @click="toApply"
        >
          确认
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
export default {
  components: { Pagination },
  data() {
    return {
      fileName: "",
      updatafileName: "",
      innerWidth: 0,
      innerHeight: 0,
      headercellstyle: {
        backgroundColor: "rgba(245, 247, 250, 1)",
        color: "rgba(51, 3, 0, 1)",
      },

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },

      dialogimportVisible: false,

      wenzi: "",
      searchValue: "",
      dataList: [
        {
          time: "2025-02-03",
          onesubject: "固定费用",
          twosubject: "固定费用",
          pricecode: "4290116007980676110",
          price: "324.3",
          order_id: "JD1234567890"
        },
        {
          time: "2025-02-03",
          onesubject: "固定费用",
          twosubject: "固定费用",
          pricecode: "4290116007980676110",
          price: "324.3",
          order_id: "JD1234567891"
        },
        {
          time: "2025-02-03",
          onesubject: "固定费用",
          twosubject: "固定费用",
          pricecode: "4290116007980676110",
          price: "324.3",
          order_id: "JD1234567892"
        },
      ],

      options: [
        { value: "选项1", label: "黄金糕" },
        { value: "选项2", label: "双皮奶" },
        { value: "选项3", label: "蚵仔煎" },
        { value: "选项4", label: "龙须面" },
        { value: "选项5", label: "北京烤鸭" },
      ],
      tempObj: {
        channelVal: "",
        typeVal: "",
      },
      // 新增批量删除相关数据
      selectedRows: [],
      batchDeleteLoading: false,
    };
  },

  created() {
    this.innerWidth = windowFun().innerWidth;
    this.innerHeight = windowFun().innerHeight;
    this.activeFun();
  },

  methods: {
    // 新增：处理表格选中行变化
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    // 新增：批量删除方法（适配delJDShouhuo接口）
    async batchDelete() {
      // 1. 校验选中数据
      if (this.selectedRows.length === 0) {
        return DonMessage.warning("请先选择需要删除的售后订单数据");
      }

      // 2. 二次确认
      try {
        await this.$confirm(
          `您确定要删除选中的 ${this.selectedRows.length} 条售后订单数据吗？`,
          "警告！",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        // 3. 开始批量删除
        this.batchDeleteLoading = true;
        let successCount = 0;
        let failCount = 0;

        // 4. 循环调用删除接口
        for (const row of this.selectedRows) {
          try {
            const res = await this.$http.get(this.$urls.delJDShouhuo, {
              order_id: row.order_id,
            });
            if (res.errcode === 0) {
              successCount++;
            } else {
              failCount++;
              console.error(`删除售后订单 ${row.order_id} 失败：`, res.errmsg);
            }
          } catch (err) {
            failCount++;
            console.error(`删除售后订单 ${row.order_id} 异常：`, err);
          }
        }

        // 5. 结果提示
        if (failCount === 0) {
          DonMessage.success(`批量删除成功！共删除 ${successCount} 条售后订单数据`);
        } else if (successCount === 0) {
          DonMessage.error(`批量删除失败！${failCount} 条售后订单数据删除失败`);
        } else {
          DonMessage.warning(`批量删除完成！成功 ${successCount} 条，失败 ${failCount} 条`);
        }

        // 6. 刷新列表 + 清空选中状态
        this.activeFun();
        if (this.$refs.orderTable) {
          this.$refs.orderTable.clearSelection();
        }
        this.selectedRows = [];
      } catch (err) {
        // 取消删除
        DonMessage.info("已取消批量删除");
      } finally {
        // 关闭加载状态
        this.batchDeleteLoading = false;
      }
    },

    //删除
    handleDelete(row) {
      this.$confirm("您确定删除么?", "警告！", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await this.$http.get(this.$urls.delJDShouhuo, {order_id: row.row.order_id });
        if (res.errcode == 0) {
          DonMessage.success("删除成功");
          this.activeFun();
        } else {
          DonMessage.error("删除失败");
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },

    downloadModel() {
      let url =
        "https://img.yimoubi.com/1-static-moban/%E4%BA%AC%E4%B8%9C%E5%94%AE%E5%90%8E%E5%8D%95.xlsx";

      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", "模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    async toApply() {
      if (!this.updatafileName) return DonMessage.error(`请上传文件`);
      let params = {
        file_path: this.updatafileName,
      };

      const res = await this.$http.post(this.$urls.importjdshouhuobiao, params);

      if (res.errcode != 0) return DonMessage.error(res.errmsg);

      this.dialogimportVisible = false;
      this.updatafileName = "";
      this.fileName = "";
      this.activeFun();
    },
    async leading(param) {
      this.listLoading = true;
      let fileObj = param.file;
      let uploadForm = new FormData();
      uploadForm.append("file", fileObj);
      const res = await this.$http.postfile(this.$urls.uploadFile, uploadForm);
      this.fileName = param.file.name;
      this.updatafileName = res.data.file_path;
    },

    async activeFun() {
      let params = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        searchText: this.searchValue,
      };
      const res = await this.$http.get(this.$urls.getjdshouhuolist, params);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.dataList = res.list;
      this.total = res.count;
    },
  },
};
</script>

<style lang="scss" scoped>
.import-mask-boxs-img {
  margin-bottom: 21px;
  img {
    width: 118px;
    height: auto;
  }
  .import-mask-boxs-img-view {
    width: fit-content;
    padding: 0px 14px 0px 17px;
    height: 68px;
    background: #f5f5f5;
    margin-top: 17px;
    border-radius: 10px;
    p {
      font-size: 18px;
      line-height: 18px;
    }
    div {
      width: 90px;
      height: 37px;
      margin-left: 48px;
      line-height: 37px;
      text-align: center;
      font-size: 14px;
      background: #195cf8;
      border-radius: 5px;
    }
  }
  .import-mask-boxs-img-text {
    font-size: 14px;
    line-height: 14px;
    margin-top: 11px;
  }
}
.plateorder {
  padding: 22px;
}
.plateorder-tabs {
  background: rgba(245, 245, 245, 1);
  border-radius: 10px;
  padding: 9px 18px 8px 47px;
  .plateorder-tabs-input {
    .shaixuan_item {
      width: 350px;
      height: 54px;
      background: #ffffff;
      border-radius: 10px;
      padding: 0 20px;
      margin-right: 22px;
      .shaixuan_item_con {
        p {
          font-size: 18px;
        }
        .shaixuan_item_arr {
          width: 13px;
          height: 8px;
          margin-left: 10px;
        }
        .shaixuan_item_icon {
          width: 29px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }

    .top_bar_inp {
      width: 372px;
      height: 54px;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      margin-right: 32px;
      padding: 0 11px;
      .top_bar_inp_img1 {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
      .top_bar_inp_inp {
        width: 282px;
      }
    }
  }
  .plateorder-tabs-input-but {
    width: 131px;
    height: 54px;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 20px;
    line-height: 54px;
    text-align: center;
  }
}

.import-mask {
  width: 100%;
  border-radius: 15px;
  background-image: url("../../../../../assets/yimou/tb.png");
  background-size: 100% 51px;
  background-repeat: no-repeat;
  padding-bottom: 40px;
  .import-mask-title {
    width: 100%;
    height: 51px;
    line-height: 51px;
    text-align: center;
    font-size: 18px;
    img {
      width: 13px;
      height: 13px;
      top: 21px;
      right: 20px;
    }
  }
  .import-mask-boxs {
    width: 650px;
    margin-top: 34px;
    .import-mask-boxs-inp {
      width: 100%;
      background: rgba(245, 245, 245, 1);
      border-radius: 10px;
      padding: 11px 22px;
      margin-bottom: 19px;
      ul {
        li:nth-of-type(1) {
          width: 145px;
          font-size: 18px;
          line-height: 18px;
          span {
            color: rgba(255, 0, 0, 1);
          }
        }
      }
    }
    .import-mask-boxs-upload {
      width: 100%;
      height: 168px;
      margin: 10px 0px 34px;
      background-image: url("../../../../../assets/yimou/hsk.png");
      img {
        width: 35px;
        height: 31px;
        margin-top: 39px;
      }
      .upload-title {
        font-size: 16px;
        line-height: 16px;
        margin: 16px 0px 13px;
        span:nth-of-type(2) {
          color: rgba(20, 75, 201, 1);
        }
      }
      .upload-content {
        font-size: 14px;
        line-height: 14px;
      }
    }
    .import-mask-ul-boxs {
      width: 24vw;
    }
  }
  .import-mask-but {
    width: 266px;
    height: 47px;
    line-height: 47px;
    text-align: center;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 17px;
  }
}

.plateorder-type {
  margin: 23px 0px;
  div {
    width: 155px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 10px;
    margin-right: 14px;
  }
  .active {
    color: rgba(255, 255, 255, 1);
    background: rgba(25, 92, 248, 1);
  }
  .activenot {
    color: rgba(35, 35, 35, 1);
    background: rgba(245, 245, 245, 1);
  }
}

.import-mask-boxs-inp .el-input /deep/.el-input__inner {
  border: none !important;
  font-size: 18px;
}
.revenbook-drawer .el-input /deep/.el-input__inner {
  border: none !important;
  background: none !important;
  font-size: 18px;
}
.el-select {
  width: 100% !important;
}
.el-select /deep/.el-input__inner {
  width: 100%;
  border: none !important;
  background: none !important;
  font-size: 18px;
}
.el-select /deep/.el-select__caret {
  color: #000000 !important;
}
.upload-demo /deep/.el-upload-dragger {
  background: none !important;
  border: none !important;
  border-radius: 0px !important;
  width: 640px !important;
  height: 168px;
}

.shaixuan_item {
  .el-input /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }
  .el-input /deep/.el-input__prefix {
    display: none !important;
  }

  .el-select /deep/.el-input__inner {
    border: none !important;
    text-align: right;
    font-size: 18px;
  }
}

/* 批量删除按钮样式 - 已设置margin-top:20px */
.batch-delete-container {
  .el-button {
    padding: 8px 15px;
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/level1/data_center/jdshouhou/index.vue